export default __webpack_public_path__ + "static/media/wallet-earnings.53f1366b.svg";